/*global toggleActionActiveStatus, addComment*/
import { toggleActionActiveStatus, addComment } from './case-page';
$('.ts-toggle-maintenance-action-active-status').on('click', function () {
    toggleActionActiveStatus($(this).data('maintenanceactionid'), $(this).data('gtmlabel'), true);
});
$('.ts-add-maintenance-comment').on('click', function () {
    var entityId = $(this).data('actionid');
    addComment(entityId, 'MaintenanceAction');
});
var descriptionBeforeEdit;
$('#start-edit-button').on('click', function () {
    var descriptionElement = document.getElementById('description');
    var startButton = document.getElementById('start-edit-button');
    var endButtons = document.getElementById('end-edit-buttons');
    descriptionBeforeEdit = descriptionElement.innerText;
    descriptionElement.setAttribute('contenteditable', 'true');
    descriptionElement.classList.add('editable-div');
    startButton.classList.add('hidden');
    endButtons.classList.remove('hidden');
});
$('.ts-save-maintenance-action').on('click', function () {
    exitEditMode(true, $(this).data('id'));
});
$('.ts-cancel-edit-maintenance-action').on('click', function () {
    exitEditMode(false);
});
function exitEditMode(saveText, actionId) {
    var descriptionElement = document.getElementById('description');
    var startButton = document.getElementById('start-edit-button');
    var endButtons = document.getElementById('end-edit-buttons');
    if (saveText) {
        if (descriptionBeforeEdit !== descriptionElement.innerText) {
            $.post({
                url: '/atgard/uppdatera-beskrivning',
                data: {
                    description: descriptionElement.innerText,
                    actionId: actionId
                },
                success: function (response) {
                    //should this be empty?
                },
                error: function (data) {
                    //should this be empty?
                }
            });
        }
    }
    else {
        descriptionElement.innerText = descriptionBeforeEdit;
    }
    descriptionElement.setAttribute('contenteditable', 'false');
    descriptionElement.classList.remove('editable-div');
    startButton.classList.remove('hidden');
    endButtons.classList.add('hidden');
}
function changePlannedYear(actionId) {
    var selectedYear = $('#select-year option:selected').val();
    $.post({
        url: '/atgard/uppdatera-ar',
        data: {
            plannedYear: selectedYear,
            actionId: actionId
        },
        success: function (response) {
            //should this be empty?
        },
        error: function (data) {
            //should this be empty?
        }
    });
}
